module.exports = __webpack_public_path__ + "img/iphone-map-POLAND-en.136aee0e.webp";